import React from 'react';
import { useSelector } from 'react-redux';

import { useIsMsk } from '@r1-frontend/entities/Layout/_deps/helpers/hooks/useIsMsk';
import { IUnauthHeaderProps } from '@r1-frontend/entities/Layout/Header/types';
import { useLeadGeneration } from '@r1-frontend/entities/Layout/Header/UnauthHeader/useLeadGeneration';
import { selectCompanyName } from '@r1-frontend/entities/stores/city/selectors';

import Button from '@r1-frontend/ui-react/components/buttons/button';

export interface IConnectionAndLoginMainViewProps {
    onOpenBecomeClientPopup: IUnauthHeaderProps['onBecomeClientHandler'],
}

const MainView = ({ onOpenBecomeClientPopup }: IConnectionAndLoginMainViewProps) => {
    const companyName = useSelector(selectCompanyName);
    const { showButton } = useLeadGeneration();
    const isMsk = useIsMsk();

    const openConnectionPopup = () => {
        onOpenBecomeClientPopup(isMsk ? 'callback' : 'connect');
    };

    if (!showButton) {
        return null;
    }

    return (
        <Button
            bType={'action'}
            size={'medium'}
            onClick={openConnectionPopup}
        >
            Подключить {companyName}
        </Button>
    );
};

export default MainView;
